import ValidationInterface from '@/plans/common/validation-interface';
import {
  basePlanCategories,
  eventsUnlimitedCategory,
  eventsPPACategory,
} from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    return [
      this.current(eventsUnlimitedCategory).require(basePlanCategories),
      this.current(eventsPPACategory).require(basePlanCategories, { billingCycleMatch: false, licenseMatch: false }),
    ];
  }

  async conflicts() {
    return [
      ...[...eventsUnlimitedCategory, ...eventsPPACategory].map((c) => [c]),
      //todo UI restriction
      ...this.current(eventsPPACategory).conflict(eventsPPACategory),
      ...this.current(eventsUnlimitedCategory).conflict(eventsPPACategory),
    ];
  }
}
